<template>
    <div id="main_view">
        <Toolbar />
        <Viewer v-if="$store.getters.isLogged" />
        <PopUp />
    </div>
</template>
<script>
import Toolbar from "../components/core/ToolbarComponent";
import Viewer from "../components/core/RouterViewComponent";
import PopUp from "../components/global/PopUpComponent";

export default {
    components: {
        Toolbar,
        Viewer,
        PopUp,
    },
};
</script>
